import { type ComponentPropsWithoutRef, forwardRef, memo, type ReactNode } from 'react';

import { cn } from '@air/utils-tailwind';

export type SearchCommandVisualSearchWellAppearance = 'outlined' | 'plain';

export type SearchCommandVisualSearchWellProps = {
  appearance: SearchCommandVisualSearchWellAppearance;
  children: ReactNode;
  isDragActive: boolean;
  isProcessing?: boolean;
} & Omit<ComponentPropsWithoutRef<'div'>, 'children'>;

export const SearchCommandVisualSearchWell = memo(
  forwardRef<HTMLDivElement, SearchCommandVisualSearchWellProps>(
    ({ appearance, children, className, isDragActive, isProcessing = false, ...rest }, ref) => (
      <div
        className={cn(
          'flex h-[184px] items-center justify-center px-4 py-8 transition-colors',
          appearance === 'outlined' && 'rounded-8 border ads:border-ads-gray-7 border-gray-7 border-dashed',
          appearance === 'plain' &&
            'rounded-12 border ads:border-ads-gray-5 border-gray-5 border-dashed ads:bg-raised bg-gray-2',
          // Inset highlight: an outer `outline` is clipped by overflow-hidden ancestors.
          isDragActive && 'ads:border-primary border-2 border-blue-9 border-solid ads:bg-primary-subtle bg-blue-1',
          isProcessing && 'opacity-50',
          className,
        )}
        ref={ref}
        {...rest}
      >
        {children}
      </div>
    ),
  ),
);

SearchCommandVisualSearchWell.displayName = 'SearchCommandVisualSearchWell';
